import * as types from './mutation_type'
import router from '../router/index'
import { setMenuList } from '../utils/index'
export default {
  [types.SET_USERINFO]: (state, userInfo) => {
    localStorage.setItem('userInfo',JSON.stringify(userInfo))
    state.userInfo = userInfo
  },
  [types.SET_TOKEN]: (state, token) => {
    localStorage.setItem('token',JSON.stringify(token))
    state.token = token
  },
  [types.SET_ISMENUSHOW]: (state, isMenuShow) => {
    state.isMenuShow = isMenuShow
  },
  [types.SET_MENULIST]: (state, menuList) => {
    // let routerObj = setMenuList(menuList)
    // router.options.routes = routerObj
    // localStorage.setItem('menuList',JSON.stringify(menuList))
    state.menuList = menuList
  },
  [types.SET_MENUSELECT]: (state, menuSelect) => {
    state.menuList = menuSelect
  },
  
}